import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const ChartComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__chartIcon"
      width={size}
      height={size}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.75 4.71429V1.5" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="3" y="4.71436" width="3.5" height="8.57143" stroke={colorVar} strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M4.75 16.4999V13.2856"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.25 4.5V1.5" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="9.5" y="4.5" width="3.5" height="6" stroke={colorVar} strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M11.25 13.5V10.5" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Chart = withIcon(ChartComponent);
